export default "__VITE_ASSET__Lhp0a30f__"